<template>
  <b-card :header="partnership_company + ' Partnership'" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
    <div class="row" v-if="!e_rec_pay_partnership">
      <!-- Partnership Taken -->
      <div class="col-lg-4 form-group">
        <label class="form-label" for="v3_gm_partnership">{{ partnership_company }} Partnership Taken</label>
        <p id="v3_gm_partnership" v-html="return_recruitment_payroll_partnership"></p>
      </div>
      <!-- Margin Type Per Worker -->
      <div class="col-lg-4 form-group" v-if="isRecruitmentPayrollPartnership">
        <label class="form-label" for="v3_gm_margin_type">{{ partnership_company }} Fee/Margin Type Per Worker</label>
        <p id="v3_gm_margin_type" v-html="return_recruitment_payroll_margin_type"></p>
      </div>
      <!-- Margin Value Per Worker -->
      <div class="col-lg-4 form-group" v-if="isRecruitmentPayrollPartnership">
        <label class="form-label" for="v3_gm_margin_amount">{{ partnership_company }} Fee/Margin Value Per Worker</label>
        <p id="v3_gm_margin_amount">
          <span v-if="ifRecruitmentPayrollMarginTypeAndValue" v-html="return_recruitment_payroll_margin_value"></span>
          <span v-else>&nbsp;</span>
        </p>
      </div>
      <!-- Company pays towards Worker Fee -->
      <div class="col-lg-4 form-group" v-if="isRecruitmentPayrollPartnership">
        <label class="form-label" for="recruitment_payroll_company_pays_toward_worker_fee">Company pays towards Worker Fee</label>
        <p id="recruitment_payroll_company_pays_toward_worker_fee" v-html="return_recruitment_payroll_company_pays_toward_worker_fee"></p>
      </div>
      <!-- Contribution towards Worker Fee (£ pound) -->
      <div class="col-lg-8 form-group" v-if="isRecruitmentPayrollPartnership">
        <label class="form-label" for="recruitment_payroll_company_fee_worker_contribution">Contribution towards Worker Fee (£ pound)</label>
        <p id="recruitment_payroll_company_fee_worker_contribution" v-html="return_recruitment_payroll_company_fee_worker_contribution"></p>
      </div>
      <!-- Worker pays towards Recruitment Fee -->
      <div class="col-lg-4 form-group" v-if="isRecruitmentPayrollPartnership">
        <label class="form-label" for="recruitment_payroll_worker_pays_toward_rec_fee">Worker pays towards Recruitment Fee</label>
        <p id="recruitment_payroll_worker_pays_toward_rec_fee" v-html="return_recruitment_payroll_worker_pays_towards_rec_fee"></p>
      </div>
      <!-- Contribution towards Recruitment Fee (£ pound) -->
      <div class="col-lg-8 form-group" v-if="isRecruitmentPayrollPartnership">
        <label class="form-label" for="recruitment_payroll_worker_rec_fee_contribution">Contribution towards Recruitment Fee (£ pound)</label>
        <p id="recruitment_payroll_worker_rec_fee_contribution" v-html="return_recruitment_payroll_worker_rec_fee_contribution"></p>
      </div>

      <div class="col-12 text-right" v-if="ifNotCompanyContactUser">
        <button @click="edit_form" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">
          Edit {{ partnership_company }} Partnership
        </button>
      </div>
    </div>
    <div class="row" v-if="e_rec_pay_partnership">
      <div class="col-12">
        <ValidationObserver ref="editRecPayPartnershipForm" slim>
          <form role="form" @submit.prevent="submit_form">
            <div class="row">
              <!-- Partnership Taken -->
              <div class="col-xl-4">
                <div class="row">
                  <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_v3_gm_partnership">
                    {{ partnership_company }} Partnership Taken</label>
                  <div class="col-xl-4 form-group">
                    <bootstrap-toggle v-model="edit_company_profile.recruitment_payroll_partnership" id="edit_v3_gm_partnership" name="edit_v3_gm_partnership"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </div>
              <!-- Margin Type Per Worker -->
              <ValidationProvider rules="" v-slot="{errors, classes}" name="Margin Type Per Worker" tag="div" class="col-xl-4 form-group"
                                  v-if="edit_company_profile.recruitment_payroll_partnership">
                <label class="form-label" for="edit_recruitment_payroll_margin_type">Margin Type Per Worker</label>
                <multiselect v-model="edit_company_profile.recruitment_payroll_margin_type" id="edit_recruitment_payroll_margin_type" placeholder="" :options="ms_opts.fee_type"
                             name="edit_recruitment_payroll_margin_type" :class="classes" label="value" track-by="id" selectLabel=""></multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Margin Value Per Worker -->
              <ValidationProvider rules="decimal" v-slot="{errors, classes}" name="Margin Value Per Worker" tag="div" class="col-xl-4 form-group"
                                  v-if="edit_company_profile.recruitment_payroll_partnership">
                <label class="form-label" for="edit_recruitment_payroll_margin_value">Margin Value Per Worker</label>
                <div class="input-group">
                  <div v-if="isEditFormMarginTypePound" class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                  <div v-else-if="isEditFormMarginTypePercentage" class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                  <input type="text" v-model="edit_company_profile.recruitment_payroll_margin_value" id="edit_recruitment_payroll_margin_value"
                         name="edit_recruitment_payroll_margin_value" class="form-input">
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Company pays towards Worker Fee -->
              <div class="col-xl-8" v-if="edit_company_profile.recruitment_payroll_partnership">
                <div class="row">
                  <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;"
                         for="edit_recruitment_payroll_company_pays_toward_worker_fee">Company pays towards Worker Fee</label>
                  <div class="col-xl-4 form-group">
                    <bootstrap-toggle v-model="edit_company_profile.recruitment_payroll_company_pays_toward_worker_fee"
                                      id="edit_recruitment_payroll_company_pays_toward_worker_fee" name="edit_recruitment_payroll_company_pays_toward_worker_fee"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </div>
              <!-- Contribution towards Worker Fee (£ pound) -->
              <ValidationProvider rules="decimal" v-slot="{errors, classes}" name="Contribution towards Worker Fee (£ pound)" tag="div" class="col-xl-4 form-group"
                                  v-if="isEditFormCompanyPaysTowardsWorkerFee">
                <label class="form-label" for="edit_recruitment_payroll_company_fee_worker_contribution">Contribution towards Worker Fee (£ pound)</label>
                <div class="input-group">
                  <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                  <input type="text" v-model="edit_company_profile.recruitment_payroll_company_fee_worker_contribution"
                         id="edit_recruitment_payroll_company_fee_worker_contribution" name="edit_recruitment_payroll_company_fee_worker_contribution" class="form-input">
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <div class="col-xl-4" v-else></div>
              <!-- Worker pays towards Recruitment Fee -->
              <div class="col-xl-8" v-if="edit_company_profile.recruitment_payroll_partnership">
                <div class="row">
                  <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;"
                         for="edit_recruitment_payroll_worker_pays_toward_rec_fee">Worker pays towards Recruitment Fee</label>
                  <div class="col-xl-4 form-group">
                    <bootstrap-toggle v-model="edit_company_profile.recruitment_payroll_worker_pays_toward_rec_fee" id="edit_recruitment_payroll_worker_pays_toward_rec_fee"
                                      name="edit_recruitment_payroll_worker_pays_toward_rec_fee" :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </div>
              <!-- Contribution towards Recruitment Fee (£ pound) -->
              <ValidationProvider rules="decimal" v-slot="{errors, classes}" name="Contribution towards Recruitment Fee (£ pound)" tag="div" class="col-xl-4 form-group"
                                  v-if="isEditFormWorkerPaysTowardsCompanyRecFee">
                <label class="form-label" for="edit_recruitment_payroll_worker_rec_fee_contribution">Worker Contribution towards Recruitment Fee (£ pound)</label>
                <div class="input-group">
                  <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                  <input type="text" v-model="edit_company_profile.recruitment_payroll_worker_rec_fee_contribution" id="edit_recruitment_payroll_worker_rec_fee_contribution"
                         name="edit_recruitment_payroll_worker_rec_fee_contribution" class="form-input">
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <div class="col-xl-4" v-else></div>
            </div>
            <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
            <div class="row mb-3 mt-2">
              <div class="col-xl-6">
                <button @click.prevent="cancel_form" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
              </div>
              <div class="col-xl-6">
                <button type="submit" class="btn orcaBtn sm_btn w-100">Update partnership information</button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </b-card>
</template>

<script>
import BootstrapToggle from 'vue-bootstrap-toggle';
import Multiselect from "vue-multiselect";
import { getChangedFields } from 'utils/utils';

export default {
  name: "partnership",
  components: {
    BootstrapToggle,
    Multiselect
  },
  props: [
    'ifNotCompanyContactUser',
    'isRecruitmentCrm',
    'isPayrollCrm',
    'company'
  ],
  data() {
    return {
      e_rec_pay_partnership: false,
      edit_company_profile: {},
      original_company_profile: {},
      ms_opts: {
        fee_type: this.$store.state.crm_options.fee_type,
      }
    }
  },
  computed: {
    /**
     * Return the CRM company
     * @returns {string}
     */
    partnership_company() {
      if (this.isRecruitmentCrm) {
        return 'GM'
      }
      else if (this.isPayrollCrm) {
        return 'V3'
      }
    },
    /**
     * If there is a partnership agreed with the company to use recruitment(V3)/payroll(GM) company
     * @returns {boolean}
     */
    isRecruitmentPayrollPartnership() {
      return this.company.rel_profile.recruitment_payroll_partnership
    },
    /**
     * Return value for if there has been a partnership agreed with the company to use recruitment(V3)/payroll(GM) company
     * @returns {string}
     */
    return_recruitment_payroll_partnership() {
      if (this.company.rel_profile.recruitment_payroll_partnership) {
        return "Yes"
      }
      else if (!this.company.rel_profile.recruitment_payroll_partnership) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * Return value of margin type agreed that the recruitment(V3)/payroll(GM) company will take
     * @returns {string}
     */
    return_recruitment_payroll_margin_type() {
      return this.company.rel_profile.recruitment_payroll_margin_type !== null
          ? this.company.rel_profile.recruitment_payroll_margin_type
          : "&nbsp;";
    },
    /**
     * If a margin type and value have been set that the recruitment(V3)/payroll(GM) company will take
     * @returns {boolean}
     */
    ifRecruitmentPayrollMarginTypeAndValue() {
      return this.company.rel_profile.recruitment_payroll_margin_type !== null && this.company.rel_profile.recruitment_payroll_margin_value !== null
    },
    /**
     * Return formatted margin value agreed to be taken by the recruitment(V3)/payroll(GM) company
     * @returns {string}
     */
    return_recruitment_payroll_margin_value() {
      if (this.company.rel_profile.recruitment_payroll_margin_type === '£ (Pound)') {
        return this.$options.filters.currency(this.company.rel_profile.recruitment_payroll_margin_value)
      }
      else if (this.company.rel_profile.recruitment_payroll_margin_type === '% (Percentage)') {
        return this.$options.filters.percentage(this.company.rel_profile.recruitment_payroll_margin_value)
      }
      else return "&nbsp;"
    },
    /**
     * Return value for if the company pays towards the worker fee
     * @returns {string}
     */
    return_recruitment_payroll_company_pays_toward_worker_fee() {
      if (this.company.rel_profile.recruitment_payroll_company_pays_toward_worker_fee) {
        return "Yes"
      }
      else if (!this.company.rel_profile.recruitment_payroll_company_pays_toward_worker_fee) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * Return value of the contribution a company makes towards a worker fee
     * @returns {string}
     */
    return_recruitment_payroll_company_fee_worker_contribution() {
      if (this.company.rel_profile.recruitment_payroll_company_fee_worker_contribution !== null) {
        return this.$options.filters.currency(this.company.rel_profile.recruitment_payroll_company_fee_worker_contribution)
      }
      else return "&nbsp;"
    },
    /**
     * Return value for if the worker pays towards the company recruitment fee
     * @returns {string}
     */
    return_recruitment_payroll_worker_pays_towards_rec_fee() {
      if (this.company.rel_profile.recruitment_payroll_worker_pays_toward_rec_fee) {
        return "Yes"
      }
      else if (!this.company.rel_profile.recruitment_payroll_worker_pays_toward_rec_fee) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * Return value of the contribution a worker makes towards a company recruitment fee
     * @returns {string}
     */
    return_recruitment_payroll_worker_rec_fee_contribution() {
      if (this.company.rel_profile.recruitment_payroll_company_fee_worker_contribution !== null) {
        return this.$options.filters.currency(this.company.rel_profile.recruitment_payroll_company_fee_worker_contribution)
      }
      else return "&nbsp;"
    },
    /* ---------------------------------------------------------------------------------------------------------
     * edit form
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * On edit form - is the margin type selected = '£ (Pound)'
     * @returns {boolean}
     */
    isEditFormMarginTypePound() {
      if (this.notEmptyObject(this.edit_company_profile) && this.edit_company_profile.recruitment_payroll_margin_type !== null) {
        return this.edit_company_profile.recruitment_payroll_margin_type.value === '£ (Pound)'
      }
      else return false
    },
    /**
     * On edit form - is the margin type selected = '% (Percentage)'
     * @returns {boolean}
     */
    isEditFormMarginTypePercentage() {
      if (this.notEmptyObject(this.edit_company_profile) && this.edit_company_profile.recruitment_payroll_margin_type !== null) {
        return this.edit_company_profile.recruitment_payroll_margin_type.value === '% (Percentage)'
      }
      else return false
    },
    /**
     * On edit form - is the company paying towards the worker fee
     * @returns {boolean}
     */
    isEditFormCompanyPaysTowardsWorkerFee() {
      return this.notEmptyObject(this.edit_company_profile)
          && this.edit_company_profile.recruitment_payroll_partnership
          && this.edit_company_profile.recruitment_payroll_company_pays_toward_worker_fee
    },
    /**
     * On edit form - is the worker paying towards the company recruitment fee
     * @returns {boolean}
     */
    isEditFormWorkerPaysTowardsCompanyRecFee() {
      return this.notEmptyObject(this.edit_company_profile)
          && this.edit_company_profile.recruitment_payroll_partnership
          && this.edit_company_profile.recruitment_payroll_worker_pays_toward_rec_fee
    }
  },
  methods: {
    /**
     * Switch vue to show form to edit partnership information
     * and set values on form
     */
    edit_form() {
      this.edit_company_profile = Object.assign({}, this.company.rel_profile);
      this.original_company_profile = Object.assign({}, this.company.rel_profile);
      if (this.company.rel_profile.recruitment_payroll_margin_type !== null) {
        this.edit_company_profile['recruitment_payroll_margin_type'] =
            this.$store.state.crm_options.fee_type.find(p => p.value === this.company.rel_profile.recruitment_payroll_margin_type);
        this.original_company_profile['recruitment_payroll_margin_type'] = this.edit_company_profile['recruitment_payroll_margin_type'];
      }
      this.$nextTick(() => this.e_rec_pay_partnership = true)
    },
    /**
     * Reset and hide the edit form
     */
    cancel_form() {
      this.edit_company_profile = {};
      this.e_rec_pay_partnership = false;
    },
    /**
     * Submit the edit form values to the database and reload vue
     */
    submit_form() {
      this.$refs.editRecPayPartnershipForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editRecPayPartnershipForm);
        }
        else {
          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);

          let company_info_promises = [];
          
          // Use the new function to get changed fields
          let changed_fields = [
            ...getChangedFields(this.original_company_profile, this.edit_company_profile),
          ];


          company_info_promises.push(new Promise(resolve => {
            let submit_cp = {
              company_id: this.company.id,
              recruitment_payroll_partnership: this.edit_company_profile.recruitment_payroll_partnership,
              recruitment_payroll_margin_type: null,
              recruitment_payroll_margin_value: this.edit_company_profile.recruitment_payroll_margin_value,
              recruitment_payroll_company_pays_toward_worker_fee: this.edit_company_profile.recruitment_payroll_company_pays_toward_worker_fee,
              recruitment_payroll_company_fee_worker_contribution: this.edit_company_profile.recruitment_payroll_company_fee_worker_contribution,
              recruitment_payroll_worker_pays_toward_rec_fee: this.edit_company_profile.recruitment_payroll_worker_pays_toward_rec_fee,
              recruitment_payroll_worker_rec_fee_contribution: this.edit_company_profile.recruitment_payroll_worker_rec_fee_contribution,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
            // if a margin type has been selected - set value to be saved to the database
            if (this.edit_company_profile.recruitment_payroll_margin_type !== null) {
              submit_cp['recruitment_payroll_margin_type'] = this.edit_company_profile.recruitment_payroll_margin_type.value
            }
            // save updates to database
            axios.patch(this.crmApiPath + 'company/profile/' + this.edit_company_profile.id, submit_cp).then(() => resolve());
          }));

          
          if (changed_fields.length > 0) {
            // Send changed fields through AJAX on email
            company_info_promises.push(new Promise(resolve => {
              axios.post(this.crmApiPath + 'company/send_changed_email', {
                title: this.partnership_company + ' Partnership',
                company_id: this.company.id,
                changes: changed_fields,
              }).then(() => resolve());
            }));
          }
          
          // Once data has been saved reload vue and hide edit form
          Promise.all(company_info_promises).then(() => {
            this.$bus.$emit('company::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            // close form
            this.$nextTick(() => {
              this.e_rec_pay_partnership = false;
            })
          });
        }
      });
    }
  },
  watch: {
    'edit_company_profile.recruitment_payroll_partnership'(val) {
      if (!val) {
        this.edit_company_profile.recruitment_payroll_margin_type = null
        this.edit_company_profile.recruitment_payroll_margin_value = ''
      }
    },
    'edit_company_profile.recruitment_payroll_company_pays_toward_worker_fee'(val) {
      if (!val) {
        this.edit_company_profile.recruitment_payroll_company_fee_worker_contribution = ''
      }
    },
    'edit_company_profile.recruitment_payroll_worker_pays_toward_rec_fee'(val) {
      if (!val) {
        this.edit_company_profile.recruitment_payroll_worker_rec_fee_contribution = ''
      }
    }
  }
}
</script>
